export class DuplicateCourseRequestDto {
  name: string;
  startDifficulty: number;
  endDifficulty: number;
  danceStyleIds: string[];
  takeoverPasses: boolean;
}
